<template>
  <div
    data-testid="post-sale-deed-feedback-loading"
    class="animate-pulse"
    aria-busy="true"
  >
    <span class="mb-10 block h-10 rounded-lais-sm bg-lais-bg-soft" />
    <span class="mb-2.5 block h-6 rounded-lais-sm bg-lais-bg-soft" />
    <span
      class="mb-10 block h-6 w-[300px] max-w-full rounded-lais-sm bg-lais-bg-soft"
    />
    <span class="mb-10 block h-6 rounded-lais-sm bg-lais-bg-soft" />
    <span
      v-for="index in 3"
      :key="index"
      class="mb-[25px] block h-[72px] rounded-lais-sm bg-lais-bg-soft"
    />
  </div>
</template>
